export const nameMap = {
    computed: {
        // 审核状态
        statusMap() {
            return new Map([
                [1, '待审核'],
                [2, '已通过'],
                [3, '已拒绝'],
                [4, '已撤销']
            ]);
        },
        // 演出类型
        activityMap() {
            return new Map([
                [1, 'Livehouse'],
                [2, '音乐节'],
                [3, '剧场'],
                [4, '演唱会']
            ]);
        }
    }
};
export const sellIdentity = {
    computed: {
        // 是否独家
        sellIdentityMap() {
            return new Map([
                [1, '独家'],
                [2, '非独家']
            ]);
        }
    }
};
export const activityStatus = {
    computed: {
        // 是否禁用场次
        activityStatus() {
            return new Map([
                [1, '启用该场次'],
                [0, '禁用该场次']
            ]);
        },
        // 票品状态
        sellStatus() {
            return new Map([
                [0, '正常销售'],
                [1, '暂停销售'],
                [2, '优惠码销售']
            ]);
        }
    }
};
